export default __webpack_public_path__ + "static/media/marketspace.be4f79da.svg";